export default __webpack_public_path__ + "static/media/gallery_17.8640c950.jpg";